import axios from 'axios';
import { MyMessage,MyStorage } from '@/common.js';

/****** request拦截器==>对请求参数做处理 ******/
axios.interceptors.request.use(
    config => {
        config.url = process.env.VUE_APP_API_URL + config.url;
        console.log('拦截器:request:config');
        if(MyStorage.getItem('api_token')){
            config.headers['Authorization'] = 'Bearer '+MyStorage.getItem('api_token');
            MyStorage.setItem('expiration',new Date().getTime()+7200000);
        }
        return config;
    },
    error => {  //请求错误处理
        console.log('拦截器:request:err',error);
        return Promise.reject(error);
    }
);


// http response 拦截器
axios.interceptors.response.use(
    response => {
        console.log('拦截器:response:success',response.status);
        return response;
    },
    error => {
        if (error.response) {
            console.log('拦截器:response:err',error);
            switch (error.response.status) {
                case 401:
                    MyStorage.removeItem("userInfo");
                    MyStorage.removeItem("api_token");
                    MyStorage.removeItem("expiration");
                    MyMessage.error('用户名密码错误 或 登录过期，请重新登录!');
                    console.log('401:鉴权失败');
                    window.location.href='/#/login';
                    break;
                case 402:
                    MyMessage.error('非管理权限!');
                    console.log('402:鉴权失败');
                    break;
                case 404:
                    MyMessage.error('接口不存在!');
                    console.log('404:接口不存在');
                    break;
                case 422:
                    MyMessage.error('用户名或密码错误!');
                    console.log('422:用户名或密码错误！');
                    break;
                case 500:
                    MyMessage.error('服务器错误!');
                    console.log('500:服务器错误');
                    break;
                default:
                    MyMessage.error('未知错误');
                    console.log('未知错误');
            }
        }
        return Promise.reject(error.response.data);   // 返回接口返回的错误信息
    }
);


var api={
    //基础方法
    base(item,then,error=null){
        item.then((res)=>{then(res)}).catch((err)=>{if(error) error(err);});
    },
    list(flag,params,then,error){
        this.base(axios.get(flag,{params:params}),then,error);
    },
    del(flag,id,then,error){
        this.base(axios.post(flag+'/'+id,{_method:'DELETE'}),then,error)
    },
    state(flag,params,then,error){
        this.base(axios.post(flag+'/changeState',params),then,error)
    },
    add(flag,params,then,error){
        this.base(axios.post(flag,params),then,error)
    },
    info(flag,id,then,error){
        this.base(axios.get(flag+'/'+id),then,error)
    },
    edit(flag,params,then,error){
        params._method='PUT';
        this.base(axios.post(flag+'/'+params.id,params),then,error)
    },
    //基础方法end

    login(params,then,error){
        this.base(axios.post('login',params),then,error);
    },
    logout(then,error){
        this.base(axios.post('logout'),then,error);
    },

    fileInfoSave(params,then,error){
        axios.post('media',params).then((res)=>{then(res)}).catch((err)=>{if(error) error(err)});
    },
    createPresignedRequest(params,then,error){
        axios.post('game/createPresignedRequest',params).then((res)=>{then(res)}).catch((err)=>{if(error) error(err)});
    },
    uploadSuccessCallBack(params,then,error){
        axios.post('game/uploadSuccessCallBack',params).then((res)=>{then(res)}).catch((err)=>{if(error) error(err)});
    },

    qiniuUpToken(params,then,error){
        axios.post('qiniuUpToken',params).then((res)=>{then(res)}).catch((err)=>{if(error) error(err)});
    },

    newUuid(then){this.base(axios.post('newUuid'),then)},
    getSTS(then){this.base(axios.post('getSTS'),then)},

	//广告系统begin
	bidding_list(param,then,error){
	  axios.post('bidding_list',param).then((res)=>{then(res)}).catch((err)=>{if(error) error(err);});
	},
	haveBiddingList(param,then,error){
	  axios.post('haveBiddingList',param).then((res)=>{then(res)}).catch((err)=>{if(error) error(err);});
	},
	doRecovery(param,then,error){
	  axios.post('doRecovery',param).then((res)=>{then(res)}).catch((err)=>{if(error) error(err);});
	},
	adBidding(then,error){
	  axios.post('adBidding').then((res)=>{then(res)}).catch((err)=>{if(error) error(err);});
	},
	doAdBidding(param,then,error){
	  axios.post('doAdBidding',param).then((res)=>{then(res)}).catch((err)=>{if(error) error(err);});
	},
	ad_list(params,then,error=null){this.list('ad',params,then,error)},
	ad_del(id,then,error=null){this.del('ad',id,then,error)},
	ad_add(params,then,error=null){this.add('ad',params,then,error)},
	ad_info(id,then,error=null){this.info('ad',id,then,error)},
	ad_edit(params,then,error=null){this.edit('ad',params,then,error)},
	//广告系统end

    media_list(params,then,error=null){this.list('media',params,then,error)},
    media_del(id,then,error=null){this.del('media',id,then,error)},

    articleType_list(params,then,error=null){this.list('articleType',params,then,error)},
    articleType_del(id,then,error=null){this.del('articleType',id,then,error)},
    articleType_add(params,then,error=null){this.add('articleType',params,then,error)},
    articleType_info(id,then,error=null){this.info('articleType',id,then,error)},
    articleType_edit(params,then,error=null){this.edit('articleType',params,then,error)},

    article_list(params,then,error=null){this.list('article',params,then,error)},
    article_del(id,then,error=null){this.del('article',id,then,error)},
    article_add(params,then,error=null){this.add('article',params,then,error)},
    article_info(id,then,error=null){this.info('article',id,then,error)},
    article_edit(params,then,error=null){this.edit('article',params,then,error)},

    tag_list(params,then,error=null){this.list('tag',params,then,error)},
    tag_del(id,then,error=null){this.del('tag',id,then,error)},
    tag_add(params,then,error=null){this.add('tag',params,then,error)},
    tag_info(id,then,error=null){this.info('tag',id,then,error)},
    tag_edit(params,then,error=null){this.edit('tag',params,then,error)},

    game_list(params,then,error=null){this.list('game',params,then,error)},
    game_del(id,then,error=null){this.del('game',id,then,error)},
    game_add(params,then,error=null){this.add('game',params,then,error)},
    game_info(id,then,error=null){this.info('game',id,then,error)},
    game_edit(params,then,error=null){this.edit('game',params,then,error)},

    category_list(params,then,error=null){this.list('category',params,then,error)},

    tag_list(params,then,error=null){this.list('tag',params,then,error)},

    material_list(params,then,error=null){this.list('material',params,then,error)},
    material_add(params,then,error=null){this.add('material',params,then,error)},
    material_info(id,then,error=null){this.info('material',id,then,error)},
    material_edit(params,then,error=null){this.edit('material',params,then,error)},


};
export default api;
